const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

const QATicketApiService = {
  // Method for handling the signup API call
  Add: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}QATicket/Create`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Add QATicket error:', error);
      throw new Error('Network error');
    }
  },

  Get: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}QATicket/Get`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  GetByUser: async (userId) => {
    try {
      const apiEndpoint = `${baseUrl}QATicket/Get/${userId}`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  Update: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}QATicket/Update`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Update QATicket error:', error);
      throw new Error('Network error');
    }
  },

  Delete: async (data) => {
    try {

      const apiEndpoint = `${baseUrl}QATicket/Delete/${data}`; // Correct URL with `/`

      const response = await fetch(apiEndpoint, {
        method: 'DELETE', // Use DELETE instead of POST
        headers: {
          'Content-Type': 'application/json',
        }
      });


      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Update QATicket error:', error);
      throw new Error('Network error');
    }
  },
  GetReplies: async (ticketId) => {
    try {

      const apiEndpoint = `${baseUrl}QATicket/GetTicketReplies?ticketId=${ticketId}`; // Correct URL with `/`

      const response = await fetch(apiEndpoint, {
        method: 'Get', 
        headers: {
          'Content-Type': 'application/json',
        }
      });


      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Update QATicket error:', error);
      throw new Error('Network error');
    }
  },
  AddReply: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}QATicket/TicketReply`; // Correct URL with `/`
      const response = await fetch(apiEndpoint, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(data)
      });


      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Update QATicket error:', error);
      throw new Error('Network error');
    }
  },
  ResolveTicket: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}QATicket/UpdateTicketStatus`; // Correct URL with `/`
      const response = await fetch(apiEndpoint, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(data)
      });


      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Update QATicket error:', error);
      throw new Error('Network error');
    }
  },
};

export default QATicketApiService;
